import React from 'react';
import { connect } from 'react-redux';

import { Container, Row, Col } from 'reactstrap';

import { MyDraggable as Draggable } from '../components/Core';
import HoverBar from '../components/HoverBar';
import Rating from '../components/Rating';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateStyle, setOverLay, l, generateImageCss } from '../functions';
import Icon from '../components/Icons';
import noImage from '../../img/nophotoproduct.jpg';
import isEqual from 'lodash/isEqual';

function mapStateToProps(state) {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    currentDevice: state.rootReducer.currentDevice || 'xl',
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

export class NewProductListTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDevice: 'xl',
    };
    this.heading = {
      h6: 16,
      h5: 20,
      h4: 24,
      h3: 26,
      h2: 30,
      h1: 32,
    };
  }

  _displayProductsList = (payload) => {
    const { titleTag = 'h4' } = (payload && payload.datas) || {};
    const MyHeadingTag = titleTag;
    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', titleTag.toUpperCase());
    if (!cssSettingsText?.fontSize) {
      cssSettingsText.fontSize = this.heading[titleTag];
    }
    const cssOldPrice = this.props.settings['old_price_color']?.color || null;
    const cssNewPrice = this.props.settings['price_color']?.color || null;

    const { productsPerRowLg, productsPerRowMd, productsPerRowSm, productsPerRowXs, showat } = (payload &&
      payload.datas) || {
      productsPerRowLg: 12,
      productsPerRowMd: 12,
      productsPerRowSm: 12,
      productsPerRowXs: 12,
    };
    const colsize = {
      xl: productsPerRowLg,
      lg: productsPerRowLg,
      md: productsPerRowMd,
      sm: productsPerRowSm,
      xs: productsPerRowXs,
    };
    let products = [];

    if (payload && payload.datas && payload.datas.productsList) products = payload.datas.productsList;

    let atclabel = l('Add to cart');
    const { priceColor, oldPriceColor, pricePosition, priceSize } = payload.datas || {};

    let priceStyle = { priceColor, oldPriceColor, pricePosition, priceSize };

    const { priceStyles } = payload['settings-' + this.props.currentDevice] || payload?.settings || {};

    if (priceStyles) {
      priceStyle = {
        ...priceStyle,
        ...priceStyles,
      };
    }

    const oldPriceSettigns = {
      color: priceStyle?.oldPriceColor || cssOldPrice || null,
      fontSize: (priceStyle?.priceSize || 16) * 0.75,
    };
    const newPriceStyle = {
      color: priceStyle?.priceColor || cssNewPrice || null,
      fontSize: priceStyle?.priceSize || 16,
    };

    if (payload.datas) {
      if (payload.datas['atclabel_' + this.props.currentLang])
        atclabel = payload.datas['atclabel_' + this.props.currentLang];
      else if (payload.datas['atclabel']) atclabel = payload.datas['atclabel'];
    }

    let settings = payload && (payload.settings || payload['settings_' + this.props.currentDevice]);
    const imageCss = generateImageCss(settings);
    const buttonFont = generateStyle(payload, 'text', 'body').fontFamily;
    const { starStyle } = payload.settings || {};

    const starCss = {
      color: starStyle?.color || 'goldenrod',
      alignment: starStyle?.starPosition || 'center',
      fontSize: starStyle?.size || 16,
    };

    return (
      (products && products.length > 0 && (
        <Container fluid={payload.fullContainer} style={cssSettings} className='products-list'>
          {setOverLay(payload)}
          <Row>
            {products.map((id_product, index) => {
              const product = this.props.fetchedProducts[id_product] || {
                image: noImage,
                name: l('Select a product'),
                price: {
                  'old-price': 99.99,
                  'reduced-price': 39.99,
                  'reduction-label': l('SALE !'),
                },
              };

              return (
                <Col className='col' key={index} xs={colsize[this.props.currentDevice] || 12}>
                  <div className='content'>
                    <div
                      className='product-img'
                      style={{
                        ...imageCss,
                        ...{ backgroundImage: `url(${product.image})` },
                      }}
                    ></div>
                    <MyHeadingTag style={cssSettingsText}>{product.name}</MyHeadingTag>
                    <Rating rate={2} on={5} style={starCss} />

                    <div
                      className='price-section'
                      style={{
                        display: 'flex',
                        justifyContent: priceStyle.pricePosition || 'center',
                      }}
                    >
                      <span className='old-price' style={oldPriceSettigns}>
                        $99.99
                      </span>

                      <span className='reduced-price' style={newPriceStyle}>
                        $9.99
                      </span>
                      <span className='price-over'>
                        Visual Builder is not showing actual product price. Prices here are used to show how it will
                        look at Store Front
                      </span>
                    </div>

                    {showat && (
                      <button
                        className='atcpl'
                        style={{
                          color: payload.datas.atcc || this.props.settings['active_button_text_color']?.color,
                          backgroundColor: payload.datas.atcbc || this.props.settings['active_button_color']?.bgColor,
                          fontFamily: buttonFont || null,
                        }}
                      >
                        {atclabel}
                      </button>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      )) || (
        <div className='gk-error-message inline'>
          <p>{l('Please select a product')}</p>
        </div>
      )
    );
  };

  shouldComponentUpdate(nextProp, nextState) {
    const nextPayload = nextProp?.payload;
    const currentPayload = this.props?.payload;
    const categories = currentPayload?.datas?.productsList;
    const nextCat = nextPayload?.datas?.productsList;
    if (categories && nextCat && categories !== nextCat) {
      return true;
    }

    if (!isEqual(nextPayload, currentPayload) || !isEqual(nextProp.settings, this.props.settings)) {
      return true;
    }
    return false;
  }

  render() {
    let { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, ...rest } = this.props;

    if (payload === null) payload = this.props.options.payload;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return this._displayProductsList(payload);
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._displayProductsList(payload)}
      </Draggable>
    );
  }
}

export default connect(mapStateToProps, null)(NewProductListTemplate);
